module.exports = __webpack_public_path__ + "static/media/img_sanlorenzo.649d2b2c.jpg";